exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotspot[data-v-919a72a0]{min-height:50px;margin:0 auto}.hotspot .img[data-v-919a72a0]{width:100%;-o-object-fit:contain;object-fit:contain;vertical-align:bottom}", ""]);

// exports
